import consts from "@/consts.js";
import Request from './request';

async function fetchByShop(id, data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/material-templates/view-by-shop/" + id, data);
}

async function fetchCombineMaterialsByShop(id, data = {}) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/material-templates/get-combine-material-rulers/" + id, data);
}

async function combineMaterialCategoryByShop(id) {
    return Request('get', "api/material-templates/get-combine-material-category/" + id);
}

export default {
    fetchByShop,
    fetchCombineMaterialsByShop,
    combineMaterialCategoryByShop,
};